export default {
  data() {
    return {
      fullStory: {
        isReady: false,
        isLoading: false,
      }
    };
  },

  methods: {
    /**
     * Wait for FullStory to load
     * @param {number} maxAttempts - max attempts (default: 20)
     * @param {number} intervalMs - interval between attempts in ms(default: 500)
     * @returns {Promise<boolean>}
     */
    waitForFullStory(maxAttempts = 10, intervalMs = 250) {
      return new Promise((resolve) => {
        let attempts = 0;

        const checkFullStory = () => {
          attempts++;

          if (window.FS && typeof window.FS.setUserVars === "function") {
            this.fullStory.isReady = true;
            this.fullStory.isLoading = false;
            resolve(true);
            return;
          }

          if (attempts >= maxAttempts) {
            this.fullStory.isLoading = false;
            resolve(false);
            return;
          }

          setTimeout(checkFullStory, intervalMs);
        };

        checkFullStory();
      });
    },

    /**
     * Initialize FullStory
     * @returns {Promise<boolean>}
     */
    async initializeFullStory() {
      this.fullStory.isLoading = true;
      return this.waitForFullStory();
    },

    /**
     * Set FullStory variables
     * @param {Object} vars - Variables to set
     * @returns {Promise<boolean>}
     */
    async setFullStoryVars(vars) {
      if (!this.fullStory.isReady) {
        await this.initializeFullStory();
      }

      if (this.fullStory.isReady && window.FS) {
        try {
          window.FS.setUserVars(vars);
          return true;
        } catch (error) {
          return false;
        }
      }
      return false;
    },

    /**
     * Identify FullStory user
     * @param {string} uid - User ID
     * @param {Object} vars - Additional variables
     * @returns {Promise<boolean>}
     */
    async identifyFullStory(uid, vars = {}) {
      if (!this.fullStory.isReady) {
        await this.initializeFullStory();
      }

      if (this.fullStory.isReady && window.FS && typeof window.FS.identify === "function") {
        try {
          window.FS.identify(uid, vars);
          return true;
        } catch (error) {
          console.info("Error identifying FS user:", error);
          return false;
        }
      }
      return false;
    }
  }
};
